// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JGby","top":"styles_top__Y8M67"};